"use client"

import { apiFetch } from "./client"

export interface AppConfig {
  booking: {
    /**
     * One-time booking: booking a court without a membership, paid per booking
     * (DOKU / reception). When false — the current default — only active members
     * may book and the online option is gone from the booking flow. DOKU itself
     * stays live for membership purchases; this flag is not a gateway switch.
     */
    one_time_enabled: boolean
  }
}

export async function getConfig(): Promise<AppConfig> {
  return apiFetch<AppConfig>("/config")
}
